<template>
  <v-select v-bind="$attrs"
            class="closd-select"
            :class="{
              'closd-select--small': small,
            }"
            :label="selectLabel"
            :items="items"
            :hide-details="hideDetails"
            :variant="variant"
            :disabled="disabled"
            density="compact"
            item-props.color="blue-darken-2"
            color="blue-darken-2"
            menu-icon="fa-caret-down"
  >
    <!-- Pass down all the slots received to VSelect to benefit from
         all its non-scoped own slots
    -->
    <template v-for="slotName in slotNames" :key="slotName" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </v-select>
</template>

<script>

/**
 * All Vuetify props for Select component are usable.
 * @see https://vuetifyjs.com/en/api/v-select/#props
 */
export default {
  name: 'AppSelect',
  inheritAttrs: false,
  props: {
    /**
     * Array of select options
     */
    items: {
      type: Array,
      required: true,
    },
    /**
     * Displayed select label
     */
    label: {
      type: String,
      default: '',
    },
    /**
     * Disable input's label
     */
    noLabel: {
      type: Boolean,
      default: false,
    },
    /**
     * Hide details space under input
     */
    hideDetails: {
      default: 'auto',
    },
    /**
     * Applies a distinct style to the component.
     */
    variant: {
      type: String,
      default: 'outlined',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectLabel () {
      if (this.noLabel) {
        return null
      }
      return this.label || this.$t('common.AppSelect.selectOption')
    },
    slotNames () {
      return Object.keys(this.$slots)
    },
  },
}
</script>

<style scoped lang="scss">

.closd-select {
  :deep(.v-select__menu-icon svg) {
    // Fix for Safari not rendering the icon otherwise.
    width: 10px;
  }
}

.closd-select.closd-select--small {
  min-width: 56px;
  :deep(.v-field__input) {
    min-height: 28px;
    padding-top: 4px;
  }

  :deep(.v-field--active .v-text-field__suffix) {
    padding-top: 2px;
    padding-bottom: 1px;
    min-height: 28px;
  }
  :deep(.v-field__append-inner) {
    padding-bottom: 3px;
  }
}
</style>
